// Read a custom markstream node's parsed attributes robustly.
//
// markstream's custom-tag parser hands a node whose `attrs` is an array
// of `[name, value]` tuples (`attrs?: [string, string][]`); the renderer
// ALSO spreads each attr as an individual prop onto the component. To
// stay resilient across library versions / either delivery path, we read
// from `node.attrs` (tuple array OR plain object) AND fall back to a
// top-level prop bag. Returns '' for a missing attr so callers can use
// `||`/`??` chains without undefined checks.

type Attrish =
  | Array<[string, string]>
  | Record<string, string>
  | null
  | undefined;

export function attr(node: { attrs?: Attrish } | null | undefined, name: string): string {
  const a = node?.attrs;
  if (!a) return '';
  if (Array.isArray(a)) {
    for (const pair of a) {
      if (Array.isArray(pair) && pair[0] === name) return String(pair[1] ?? '');
    }
    return '';
  }
  if (typeof a === 'object') {
    const v = (a as Record<string, string>)[name];
    return v == null ? '' : String(v);
  }
  return '';
}
